

import type { TExtendedLoginMediums } from "@buzzwaretech/types";

export const EXTENDED_LOGIN_MEDIUM_LABELS: Record<
  TExtendedLoginMediums,
  string
> = {};
